import * as Style from './style';
import * as Comp from './components';
import { MuiButton } from '~/Components/Form';
import { useModalContext } from '~/Provider/ModalProvider';
import { Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import HookPayPoints from './hooks';
import Dots from '../../../Components/Loader/Dots';
const PayPoints = () => {
    const { LoadingPoints, LoadingPaymentsMethod } = HookPayPoints()
    const { openpaypoints } = useModalContext()
    const points = useSelector((state) => state.PayPointsSlice.points)
    const payments = useSelector((state) => state.PayPointsSlice.payments)

    console.log("the data is ", points, payments)
    return (
        <Style.Section>
            {
                !LoadingPoints && !LoadingPaymentsMethod ?
                    <>
                        <Style.RightSection>
                            <Comp.Points />
                        </Style.RightSection>
                        <Style.LeftSection>
                            <Comp.PayMethod />
                            <Tooltip title={points === "" || payments === "" ? "يرجى اختيار الطريقة وعدد النقاط " : null}>
                                <MuiButton text='شراء' margin='20px 0' onClick={points === "" || payments === "" ? null : openpaypoints} />
                            </Tooltip>
                        </Style.LeftSection>
                    </>
                    : <div style={{ height: '80Vh', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Dots /></div>
            }

        </Style.Section>
    )
}

export default PayPoints